<template>
  <div class="crm-salon-root">
    <div class="crm-shell">
      <aside class="crm-aside">
        <div class="crm-aside-brand">
          <div class="crm-aside-logo" aria-hidden="true"><i class="tim-icons icon-single-02"></i></div>
          <div style="min-width:0">
            <div class="crm-aside-name">CRM</div>
            <div class="crm-aside-sub">{{ salonMode ? 'Mode salon' : 'Mode interne' }}</div>
          </div>
        </div>
        <router-link class="crm-link-platform" :to="{ name: 'Dashboard layout' }">← Plateforme Weedo</router-link>
        <nav>
          <router-link
            v-for="item in navDesktopFiltered"
            :key="item.to"
            :to="item.to"
            :exact="item.to === '/crm-salon'"
            :class="{ active: isActive(item.to) }"
          >
            <i :class="item.icon"></i>
            <span>{{ item.label }}</span>
          </router-link>
        </nav>
        <button type="button" class="crm-aside-mode" @click="toggleSalon">
          {{ salonMode ? 'Passer en interne' : 'Passer en salon' }}
        </button>
        <div class="crm-aside-user">
          <div class="crm-aside-logo" style="font-size:11px">{{ initials }}</div>
          <div style="min-width:0">
            <div class="crm-aside-user-name">{{ userLabel }}</div>
            <div class="crm-aside-user-meta">Weedoit</div>
          </div>
        </div>
      </aside>

      <div class="crm-main">
        <header class="crm-header">
          <div class="crm-header-title">CRM</div>
          <input
            v-if="showSearch"
            class="crm-input"
            style="flex:1;width:100%;min-width:0"
            v-model="quickQ"
            placeholder="Nom, société, email, tél, ORIAS…"
            @keyup.enter="goSearch"
          />
          <span class="crm-toggle" :class="salonMode ? 'on' : 'off'" aria-live="polite">
            {{ salonMode ? 'Salon' : 'Interne' }}
          </span>
        </header>
        <main class="crm-content">
          <router-view></router-view>
        </main>
      </div>
    </div>

    <nav class="crm-bottom-nav">
      <router-link
        v-for="item in navMobileFiltered"
        :key="item.to"
        :to="item.to"
        :exact="item.to === '/crm-salon'"
        :class="{ active: isActive(item.to) }"
      >
        <i :class="item.icon"></i>
        {{ item.label }}
      </router-link>
    </nav>
  </div>
</template>

<script>
const SALON_KEY = 'crm_salon_mode'

/** Routes réservées au mode interne */
const INTERNE_ONLY_PREFIXES = ['/crm-salon/a-faire', '/crm-salon/champs', '/crm-salon/salons']

const NAV_SALON = [
  { to: '/crm-salon', label: 'Visite', icon: 'tim-icons icon-single-02' },
  { to: '/crm-salon/carnet', label: 'Carnet', icon: 'tim-icons icon-book-bookmark' },
  { to: '/crm-salon/pipeline', label: 'Pipeline', icon: 'tim-icons icon-chart-bar-32' },
  { to: '/crm-salon/journee', label: 'Journée', icon: 'tim-icons icon-chart-pie-36' }
]

const NAV_INTERNE_EXTRA = [
  { to: '/crm-salon/a-faire', label: 'À faire', icon: 'tim-icons icon-check-2' },
  { to: '/crm-salon/champs', label: 'Champs', icon: 'tim-icons icon-settings-gear-63' },
  { to: '/crm-salon/salons', label: 'Salons', icon: 'tim-icons icon-calendar-60' }
]

export default {
  name: 'DashboardLayoutCrmSalon',
  data() {
    let user = {}
    try {
      user = JSON.parse(localStorage.getItem('utilisateur') || '{}')
    } catch (e) {}
    const stored = localStorage.getItem(SALON_KEY)
    return {
      salonMode: stored === '1',
      quickQ: '',
      user
    }
  },
  computed: {
    userLabel() {
      return [this.user.first_name, this.user.last_name].filter(Boolean).join(' ') || this.user.email || 'Commercial'
    },
    initials() {
      const a = (this.user.first_name || 'C')[0]
      const b = (this.user.last_name || 'S')[0]
      return (a + b).toUpperCase()
    },
    showSearch() {
      return this.$route.path === '/crm-salon' || this.$route.path.indexOf('/crm-salon/carnet') === 0
    },
    navDesktopFiltered() {
      if (this.salonMode) return NAV_SALON
      return NAV_SALON.concat(NAV_INTERNE_EXTRA)
    },
    navMobileFiltered() {
      if (this.salonMode) return NAV_SALON
      // Mobile interne : + À faire + Salons (Champs reste desktop)
      return NAV_SALON.concat([NAV_INTERNE_EXTRA[0], NAV_INTERNE_EXTRA[2]])
    }
  },
  watch: {
    salonMode() {
      this.guardInterneRoute()
    },
    '$route.path'() {
      this.guardInterneRoute()
    }
  },
  created() {
    this.ensureJakartaFont()
    this.guardInterneRoute()
    if (typeof document !== 'undefined') document.body.classList.add('crm-salon-open')
  },
  beforeDestroy() {
    if (typeof document !== 'undefined') document.body.classList.remove('crm-salon-open')
  },
  methods: {
    ensureJakartaFont() {
      if (typeof document === 'undefined') return
      if (document.getElementById('crm-salon-jakarta')) return
      const link = document.createElement('link')
      link.id = 'crm-salon-jakarta'
      link.rel = 'stylesheet'
      link.href = 'https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap'
      document.head.appendChild(link)
    },
    isInterneOnlyPath(path) {
      return INTERNE_ONLY_PREFIXES.some(p => path === p || path.indexOf(p + '/') === 0)
    },
    guardInterneRoute() {
      if (this.salonMode && this.isInterneOnlyPath(this.$route.path)) {
        this.$router.replace({ path: '/crm-salon' })
      }
    },
    toggleSalon() {
      this.salonMode = !this.salonMode
      localStorage.setItem(SALON_KEY, this.salonMode ? '1' : '0')
    },
    isActive(to) {
      if (to === '/crm-salon') return this.$route.path === '/crm-salon'
      return this.$route.path.indexOf(to) === 0
    },
    goSearch() {
      if (this.quickQ.trim().length >= 2) {
        this.$router.push({ path: '/crm-salon', query: { q: this.quickQ.trim() } })
      }
    }
  },
  provide() {
    return {
      crmSalonMode: this
    }
  }
}
</script>

<style>
@import '~@/assets/css/crm-salon.css';
</style>
